export default "__VITE_ASSET__64dee44b__"